module.exports = __webpack_public_path__ + "static/portfolio-9-99d2a31f339dc1f1cf33420c9c3038dc.jpg";